// extracted by mini-css-extract-plugin
module.exports = {"fixedCartButton":"start_fixedCartButton__1OrfP","fadeIn":"start_fadeIn__1sXrJ","fixedCartButtonClosing":"start_fixedCartButtonClosing__1FYa8","fadeOut":"start_fadeOut__2ijfp"};